// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__ZYhwi","bigColWidth":"Table_bigColWidth__2m6SM","biggerColWidth":"Table_biggerColWidth__2ZGNS","row":"Table_row__2hamf","col":"Table_col__2CvZF"};